import type { TextBlock } from "~/core";

export const isTextBlock = (item: unknown): item is TextBlock => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "text_block" &&
    "content" in item &&
    item.content !== null
  );
};
